// Fotos demo de Unsplash por categoría
// Todas las URLs son estables y gratuitas (licencia Unsplash)

export const DEMO_PHOTOS = {
  Matrimonios: [
    {
      id: 'demo-wed-1',
      url: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=800&q=80&auto=format&fit=crop',
      alt: 'Pareja de novios',
    },
    {
      id: 'demo-wed-2',
      url: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=800&q=80&auto=format&fit=crop',
      alt: 'Ramo de novia',
    },
    {
      id: 'demo-wed-3',
      url: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800&q=80&auto=format&fit=crop',
      alt: 'Anillos de boda',
    },
    {
      id: 'demo-wed-4',
      url: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=800&q=80&auto=format&fit=crop',
      alt: 'Mesa decorada',
    },
    {
      id: 'demo-wed-5',
      url: 'https://images.unsplash.com/photo-1522413452208-996ff3f3e740?w=800&q=80&auto=format&fit=crop',
      alt: 'Pareja caminando',
    },
    {
      id: 'demo-wed-6',
      url: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=800&q=80&auto=format&fit=crop',
      alt: 'Detalles de boda',
    },
  ],

  Cumpleaños: [
    {
      id: 'demo-bd-1',
      url: 'https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80&auto=format&fit=crop',
      alt: 'Pastel de cumpleaños',
    },
    {
      id: 'demo-bd-2',
      url: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80&auto=format&fit=crop',
      alt: 'Globos de colores',
    },
    {
      id: 'demo-bd-3',
      url: 'https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=800&q=80&auto=format&fit=crop',
      alt: 'Velas de cumpleaños',
    },
    {
      id: 'demo-bd-4',
      url: 'https://images.unsplash.com/photo-1578922746465-3a80a228f223?w=800&q=80&auto=format&fit=crop',
      alt: 'Confeti',
    },
    {
      id: 'demo-bd-5',
      url: 'https://images.unsplash.com/photo-1513151233558-d860c5398176?w=800&q=80&auto=format&fit=crop',
      alt: 'Decoración fiesta',
    },
    {
      id: 'demo-bd-6',
      url: 'https://images.unsplash.com/photo-1533294379132-52f27c6c2b7c?w=800&q=80&auto=format&fit=crop',
      alt: 'Mesa dulce',
    },
  ],

  'Baby Shower': [
    {
      id: 'demo-bs-1',
      url: 'https://images.unsplash.com/photo-1519689680058-324335c77eba?w=800&q=80&auto=format&fit=crop',
      alt: 'Decoración baby shower',
    },
    {
      id: 'demo-bs-2',
      url: 'https://images.unsplash.com/photo-1544126592-807ade215a0b?w=800&q=80&auto=format&fit=crop',
      alt: 'Zapatitos de bebé',
    },
    {
      id: 'demo-bs-3',
      url: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?w=800&q=80&auto=format&fit=crop',
      alt: 'Osito de peluche',
    },
    {
      id: 'demo-bs-4',
      url: 'https://images.unsplash.com/photo-1522771930-78848d9293e8?w=800&q=80&auto=format&fit=crop',
      alt: 'Globos pastel',
    },
    {
      id: 'demo-bs-5',
      url: 'https://images.unsplash.com/photo-1537261131936-3cf3dbef9791?w=800&q=80&auto=format&fit=crop',
      alt: 'Pastel baby shower',
    },
    {
      id: 'demo-bs-6',
      url: 'https://images.unsplash.com/photo-1607006344380-b6775a0824ce?w=800&q=80&auto=format&fit=crop',
      alt: 'Decoración infantil',
    },
  ],

  Bautizos: [
    {
      id: 'demo-ch-1',
      url: 'https://images.unsplash.com/photo-1543556153-51a4c4feb1b4?w=800&q=80&auto=format&fit=crop',
      alt: 'Bautizo',
    },
    {
      id: 'demo-ch-2',
      url: 'https://images.unsplash.com/photo-1509909756405-be0199881695?w=800&q=80&auto=format&fit=crop',
      alt: 'Velas y cruz',
    },
    {
      id: 'demo-ch-3',
      url: 'https://images.unsplash.com/photo-1507692049790-de58290a4334?w=800&q=80&auto=format&fit=crop',
      alt: 'Iglesia',
    },
    {
      id: 'demo-ch-4',
      url: 'https://images.unsplash.com/photo-1490730141103-6cac27aaab94?w=800&q=80&auto=format&fit=crop',
      alt: 'Flores blancas',
    },
    {
      id: 'demo-ch-5',
      url: 'https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?w=800&q=80&auto=format&fit=crop',
      alt: 'Cristales',
    },
    {
      id: 'demo-ch-6',
      url: 'https://images.unsplash.com/photo-1600369672770-985fd30004eb?w=800&q=80&auto=format&fit=crop',
      alt: 'Detalles',
    },
  ],

  Graduaciones: [
    {
      id: 'demo-gr-1',
      url: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&q=80&auto=format&fit=crop',
      alt: 'Graduados',
    },
    {
      id: 'demo-gr-2',
      url: 'https://images.unsplash.com/photo-1627556704302-624286467c65?w=800&q=80&auto=format&fit=crop',
      alt: 'Birrete',
    },
    {
      id: 'demo-gr-3',
      url: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800&q=80&auto=format&fit=crop',
      alt: 'Ceremonia',
    },
    {
      id: 'demo-gr-4',
      url: 'https://images.unsplash.com/photo-1564981797816-1043664bf78d?w=800&q=80&auto=format&fit=crop',
      alt: 'Diploma',
    },
    {
      id: 'demo-gr-5',
      url: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=800&q=80&auto=format&fit=crop',
      alt: 'Celebración',
    },
    {
      id: 'demo-gr-6',
      url: 'https://images.unsplash.com/photo-1607013251379-e6eecfffe234?w=800&q=80&auto=format&fit=crop',
      alt: 'Aplausos',
    },
  ],
};

export const getDemoPhotos = (category) =>
  DEMO_PHOTOS[category] || DEMO_PHOTOS.Matrimonios;